export const DEFAULT_INTERCOM_POSITION = {
  alignment: 'right',
  horizontal_padding: 20,
  vertical_padding: 20,
};


export const INTERCOM_POSITION_BY_PATH = {
  '/unibox': {
    vertical_padding: 155,
    z_index: 100,
  },
  '/automation/flow-builder': {
    vertical_padding: 80,
  },
  '/create-campaign': {
    vertical_padding: 70,
  },

};

const PATH_PREFIX_RULES = [
  { prefix: '/automation', position: { vertical_padding: 80 } },
];

export const getIntercomPositionForPath = pathname => {
  const path = pathname?.split('?')[0] || '';

  if (INTERCOM_POSITION_BY_PATH[path]) {
    return { ...DEFAULT_INTERCOM_POSITION, ...INTERCOM_POSITION_BY_PATH[path] };
  }

  const prefixRule = PATH_PREFIX_RULES.find(({ prefix }) => path.startsWith(prefix));
  if (prefixRule) {
    return { ...DEFAULT_INTERCOM_POSITION, ...prefixRule.position };
  }

  return DEFAULT_INTERCOM_POSITION;
};
